import type { BillingInterval, SubscriptionTier } from "./types";

/** Solo is always billed monthly, whatever interval was selected. */
export const getChargedBillingInterval = (
  plan: SubscriptionTier,
  selectedBillingInterval: BillingInterval,
): BillingInterval => (plan === "SOLO" ? "MONTHLY" : selectedBillingInterval);
